import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { ICategory } from 'sections/Company/Faqs/types';
import styles from 'sections/Company/Faqs/SectionContent/Navigation/NavigationItem/NavigationItem.module.scss';

const cn = classNames.bind(styles);

interface NavigationItemProps {
  item: ICategory;
  isActive: boolean;
  action: (event: React.MouseEvent<HTMLElement>, id: number) => void;
  children?: ICategory | ICategory[] | any;
  hideLabel: boolean;
};

const NavigationItem: FC<NavigationItemProps> = ({
  item,
  isActive,
  action,
  children,
  hideLabel,
}): ReactElement => {
  return (
    <li
      className={cn('navigation-item', {
        'isActive': isActive,
        'isChilditem': isActive && item.parent_id,
      })}
      onClick={(event) => action(event, item.id)}
    >
      {hideLabel &&
        <span className={cn('navigation-item__text', {
          'isMain': !item.parent_id,
          'isChild': !!item.parent_id,
        })}>
          {item.name}
        </span>
      }
      {children}
    </li>
  );
};

export { NavigationItem };
